<template>
	<section>
		<titlebar :title-stack="titleStack"></titlebar>
		<div v-if="isLoading">
			<b-loading active></b-loading>
		</div>
		<div v-else>
			<div class="columns is-multiline">
				<div
					v-for="(card, index) in cards"
					:key="index"
					class="column is-2"
				>
					<p class="title is-size-5 has-text-centered is-4">
						{{ card.title }}
					</p>
					<div @click="navigateTo(card)" class="card custom-card is-flex is-flex-direction-column has-text-centered">
						<div class="card-content px-0">
							<div class="content has-text-white">
								<span v-if="card.quantidade" 
                                    :class="getClass(card)">
                                    {{ card.quantidade }}
                                </span>
								<div v-if="card.valorTotal">
									{{ card.valorTotal }}
								</div>
                                <div v-if="card.title == 'Vendas no ano' && card.media">
									{{ card.media }} T
								</div>
                                <div v-if="card.instalacoes">
                                    <p>Normal {{ card.instalacoes.filter(tipo => tipo == 1).length }}</p>
                                    <p>Assistência {{ card.instalacoes.filter(tipo => tipo == 2).length }}</p>
                                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
    .custom-card {
        background-color: #000 !important;
        border-radius: 15px !important;
        margin: 8px;
        min-height: 7.5rem;
        transition: transform 0.3s ease, background-color 0.3s ease;
    }

    .custom-card:hover {
		transform: scale(1.1);
		background-color: rgba(0, 0, 0, 0.95) !important;
		cursor: pointer;
	}

    .content {
        font-size: 1rem;
        line-height: 1.5;
    }
</style>

<script>
    import titlebar from "@/components/titlebar.vue";
    import { mapState } from "vuex";

    export default {
        data() {
            return {
                isLoading: false,
                cards: [],
            };
        },
        components: {
            titlebar,
        },
        computed: {
            titleStack() {
                return [
                    "Relatório",
                    "Dashboard",
                    "Geral"
                ];
            },
            ...mapState(
                [
                    "usuario",
                    "unidadeId"
                ]
            ),
        },      

        mounted() {

            this.loadAsyncData();
            
        },        
        methods: {
            async loadAsyncData() {
                await this.carregarDados();
            },
            isAdministrador() {
                return (
                    this.usuario.nivel == "Administrador" || this.usuario.nivel == "Franqueado"                     
                );
            },            

            carregarDados() {                                                                           
                    this.isLoading = true;   
                    
                    const params = [];      
                    
                    if(!this.isAdministrador())                                
                        params.push(`unidadeId=${this.unidadeId}`)                    


                    this.$http.get(`/api/relatorio/DashboardGeral?${params.join('&')}`)
                            .then(res => res.data)
                            .then(data => {
                            this.cards = data                        
                        })
                        .catch((error) => {
                            throw error
                        })
                        .finally(() => {
                            this.isFetching = false
                            this.isLoading = false;
                        })                
                

            },

            getClass(card) {
                if (card.quantidade.includes('%')) {
                    const quantidade = parseFloat(card.quantidade.replace('%', '').trim());
                    if (quantidade >= 80) {
                        return 'has-text-info';
                    } 
                    else if (quantidade < 80 && quantidade > 30) {
                        return 'has-text-warning';
                    }
                    else{
                        return 'has-text-danger';
                    }
                }

                return '';
            },
            navigateTo(card) {
				this.$router.push({ name: 'cardlist', query: this.defineParams(card) });				
			},
			defineParams(card) {
				const params = {
                    fromDashboard: 'Geral',
                    card: card.title
                };
				
				return params;
			}
        },
    };
</script>